import Message from './Message';

export default (function (w, d) {
    'use strict';

    function AddToCartButton() {
        this.init();
    }

    AddToCartButton.prototype.init = function () {
        $(function () {
            $('.add-btn').click(function (e) {
                e.preventDefault();
                e.stopPropagation();

                const product_id = $(this).attr('data-id'),
                    attribute_id = $(this).attr('data-attribute-id'),
                    qty = $('#qty').val();

                const url = $(this).attr('data-url') ? $(this).attr('data-url') : route_add_to_cart;

                const args = {
                    product_id: product_id,
                    product_attribute_id: attribute_id ? attribute_id : $('#product_attribute_id').val(),
                    qty: qty ? qty : 1
                };

                $.post(url, args, function(response) {
                    if (response.status === 'success') {
                        $('.mini-cart-count').text('(' + response.total_cart_products + ')');
                        $('.mini-cart .price .amount').text(response.total_cart_sum);
                        $('.mini-cart-wrapper').html(response.cart_products_html);
                        $('.mini-cart .bottom-bar').addClass('active');

                        $('.mini-cart-count').removeClass('d-none');
                        $('.products').removeClass('d-none');
                        $('.no-products').addClass('d-none');

                        new Message(response.message, 'success');
                    } else {
                        new Message(response.message, 'error');
                    }
                });
            });
        });
    }

    return AddToCartButton;
}(window, document));

